import { Flex, Heading, Image } from "@chakra-ui/react";
import React from "react";
import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";
import LangButtons from "../../LangButtons/LangButtons";

const NavbarDesktop = ({ isRegistered, logout }) => {
  return (
    <Flex
      justify="space-between"
      h="13vh"
      align="center"
      backgroundColor="#211f20"
      pr="10%"
    >
      <NavLink style={{width: "250px"}} to="/">
        <Image
          w="100%"
          ml="20px"
          src="https://res.cloudinary.com/dhp2zuftj/image/upload/v1650051041/MontseProyect/logoNegro.png"
          alt="icono KLS"
        />
      </NavLink>
      
      <NavLink w="250px" to="/">
        <Heading color="#f2f4f6"><FormattedMessage id="app.navbar.inicio"/></Heading>
      </NavLink>
      <NavLink w="250px" to="/novedades">
        <Heading color="#f2f4f6"><FormattedMessage id="app.navbar.novedades"/></Heading>
      </NavLink>
      <NavLink w="250px" to="/ganadores">
        <Heading color="#f2f4f6"><FormattedMessage id="app.navbar.ganadores"/></Heading>
      </NavLink>
      <NavLink w="250px" to="/contacto">
        <Heading color="#f2f4f6"><FormattedMessage id="app.navbar.contacto"/></Heading>
      </NavLink>
      {isRegistered ? (
        <Image
          filter="brightness(0) invert(1)"
          w="40px"
          cursor="pointer"
          onClick={() => logout()}
          src="https://www.svgrepo.com/show/67681/logout.svg"
          alt="logout"
        />
      ) : (
        <NavLink w="250px" to="/login">
          <Heading color="#f2f4f6">Login</Heading>
        </NavLink>
      )}
      <LangButtons layout="desktop"/>
    </Flex>
  );
};

export default NavbarDesktop;